module.exports = __webpack_public_path__ + "img/file-text.af4e99b6.svg";